import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import {
  GlobalFunctions
} from 'globales-projekt-angular';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';

@Component({
  selector: 'app-pseudonymisierungVerfahren',
  templateUrl: './pseudonymisierungVerfahren.component.html',
  styleUrls: ['./pseudonymisierungVerfahren.component.css'],
})
export class PseudonymisierungVerfahrenComponent implements OnInit {
  anwendungsname = ConstantsTexte.ANWENDUNGSNAME;

  faArrowLeft = faArrowLeft;

  cssString: string;

  constructor(private location: Location) {}

  ngOnInit(): void {
    this.cssString = GlobalFunctions.setNavBarDropdownRedColorSelect();
  }
  goBack() {
    this.location.back();
  }

  public ngOnDestroy() {
    GlobalFunctions.setNavBarDropdownRedColorDeSelect(this.cssString);
  }
}
